<template>
<v-row>
    <v-col  cols="12" sm="12" md="12">
            <v-row>
                <v-col  cols="12" sm="12" md="12">
                    <botaoVoltar />
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <h2>DADOS DA SOLICITAÇÃO</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-row>
                        <v-col cols="12" sm="12" md="12">{{ this.descricaoOrigemProcura }}<span v-show="this.testTextHasValue(this.descricaoOrgao)"> / {{ this.descricaoOrgao }}</span></v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span>Protocolo: </span>{{ idSolicitacao }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" md="6">
                            <span>Data: </span>{{ dataHoraSolicitacao  | formatDate_BR() }}
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                            <span>Situação: </span>{{ descricaoStatusSolicitacao }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" md="6">
                            <span>Perfil da solicitação: </span>{{ descricaoTipoPerfilSolicitacao }}
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                            <span>Tipo: </span>{{ descricaoTipoSolicitacao }}
                        </v-col> 
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span>Motivo do {{ (tipoSolicitacao == 'R') ? "reordenamento" : "acolhimento" }}: </span>{{ (tipoSolicitacao == 'R') ? descricaoMotivoReordenamento : descricaoMotivoProcura }}
                        </v-col>
                    </v-row> 
                    <v-row v-show="tipoPerfilSolicitacao == 'G'">
                        <v-col cols="12" sm="12" md="12"><span>Aceita acolhimento separado? </span>  
                        <span :class="(acolhimentoSeparado == 'Sim')? 'green--text' : 'red--text'">{{ acolhimentoSeparado }}</span></v-col>
                    </v-row>   
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <span>Tipo de serviço para {{ (tipoSolicitacao == 'R') ? "reordenamento" : "acolhimento" }}: </span>{{ descricaoTipoServico }}
                        </v-col>                      
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" md="4">
                            <span>Breve relato da solicitação: </span>
                        </v-col>
                        <v-col cols="6" sm="6" md="8">
                            {{ breveRelato }}
                        </v-col>
                    </v-row> 
                </v-col>       
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>
            
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">
                    <h3>Solicitação Indeferida</h3>
                </v-col>
            </v-row>
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">
                    <span class="font-weight-bold">Motivo: </span>{{ motivoIndeferimento }}
                </v-col>
            </v-row>
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">
                    <span class="font-weight-bold">Descrição: </span>{{ descricaoMotivoIndeferimento }}
                </v-col>
            </v-row>
            <v-row v-show="descricaoStatusSolicitacao=='Indeferida'">
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>          
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <h3>Responsável pela Solicitação</h3>
                </v-col> 
            </v-row>      
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <span>Nome: </span>{{ nomeResponsavelSolicitacao }}
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <span>Telefone para comunicação: </span>{{ telefoneResponsavelSolicitacao | TelefoneFormatado }}
                </v-col>
            </v-row>      
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <span>E-mail para comunicação 1: </span>{{ emailResponsavelSolicitacao }}
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <span>E-mail para comunicação 2: </span>{{ emailResponsavelSolicitacaoSecundario }}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>     
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <h3>Endereço de Referência do(s) Cidadão(s)</h3>
                </v-col>
            </v-row>                 
            <v-row>
                <v-col cols="12" sm="12" md="12">
                  <p>CEP: {{ enderecoSolicitacao.cep }}</p>
                  <p>Logradouro: {{ enderecoSolicitacao.siglaLogradouro }} {{ enderecoSolicitacao.nomeLogradouro }}, {{ enderecoSolicitacao.numeroLogradouro }}<span v-if="(enderecoSolicitacao.complemento != null && enderecoSolicitacao.complemento.length > 0)"> - Complemento: {{ enderecoSolicitacao.complemento }}</span></p>
                  <p><span v-if="(enderecoSolicitacao.pontoReferencia != null && enderecoSolicitacao.pontoReferencia.length > 0)"> - Referência: {{ enderecoSolicitacao.pontoReferencia }} </span></p>
                  <p>Subprefeitura: {{ enderecoSolicitacao.DescricaoSubprefeitura }} - Distrito: {{ enderecoSolicitacao.DescricaoDistrito }}</p>
                </v-col>
            </v-row>        
            <v-row>
                <v-col cols="12" sm="12" md="12">   
                    <v-divider></v-divider>   
                </v-col> 
            </v-row>  
            <v-row>
                <DetailCitizen
                    v-for="citizen in listCitizen"
                    v-bind:citizen="citizen"
                    v-bind:idSolicitacao="idSolicitacao"
                    v-bind:key="citizen.codigoCidadaoSolicitacao"
                ></DetailCitizen>
            </v-row>
    </v-col>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />
        <br/>
</v-row>
</template>

<script>
import { mapGetters } from "vuex";
import snackbarMixin from "@/mixins/snackbar.mixin";
import goBack from '../GoBack.vue';
import requestService from '../../services/request.service';
import DetailCitizen from '../citizen/CitizenDetailPrint.vue';
import loginService from '../../services/security/login.service';

export default {
    mixins: [snackbarMixin],
    components:{
        'botaoVoltar': goBack,
        DetailCitizen,
    },    
    data(){
        return{
            headers: [
                { text: "Nome", value: "nome" },
                { text: "Nome da mãe", value: "nomeMae" },
                { text: "Data de Nascimento", value: "dataNascimento" },
            ],
            loading: false,
            nodata: true,
            error: "",
            idSolicitacao:'',
            descricaoMotivoProcura:'',
            descricaoMotivoReordenamento:'',
            descricaoStatusSolicitacao:'',
            descricaoTipoPerfilSolicitacao:'',
            dataHoraSolicitacao: '',
            nomeResponsavelSolicitacao: '',
            emailResponsavelSolicitacao: '',
            emailResponsavelSolicitacaoSecundario: '',
            telefoneResponsavelSolicitacao: '',
            breveRelato: '',
            enderecoSolicitacao: '',
            descricaoTipoSolicitacao: '',
            listCitizen: [],
            showModalCitizen: false,
            codigoTipoServicoReordenamento: '',
            descricaoTipoServico: '',
            tipoSolicitacao: '',
            acolhimentoSeparado:'',
            tipoPerfilSolicitacao:'',
            motivoIndeferimento:'',
            descricaoMotivoIndeferimento:'',
            descricaoOrigemProcura:'',
            descricaoOrgao:''
        }
    },
    computed:{
        ...mapGetters("request", ["listRequest"])
    },
    watch: {
        list: function () {
            if (this.listRequests <= 0) {
                this.nodata = true;
            } else {
                this.nodata = false;
            }
        },
        options: {
            handler() {
                this.search();
            },
            deep: true,
        },
        showModalCitizen(value) {
            if(value){
                this.$refs.mdShowCitizen.clear();
            }
        },        
    },
    mounted() {
        if(this.$route.params.id){
            requestService.getSolicitacaoById(this.$route.params.id)
            .then(result =>{
                if(result.status == 200 && result.data){
                    let r = result.data;
                    if(r){
                        this.idSolicitacao = r.idSolicitacao.toString().padStart(8,'0');
                        this.descricaoMotivoProcura = r.descricaoMotivoProcura;
                        this.descricaoMotivoReordenamento = (r.descricaoMotivoReordenamento != null && r.descricaoMotivoReordenamento != undefined) ? r.descricaoMotivoReordenamento : "";
                        this.descricaoStatusSolicitacao = r.descricaoStatusSolicitacao;
                        this.descricaoTipoPerfilSolicitacao = r.descricaoTipoPerfilSolicitacao;
                        this.dataHoraSolicitacao = r.dataHoraSolicitacao;
                        this.nomeResponsavelSolicitacao = r.nomeResponsavelSolicitacao;
                        this.emailResponsavelSolicitacao = r.emailResponsavelSolicitacao;
                        this.emailResponsavelSolicitacaoSecundario = r.emailResponsavelSolicitacaoSecundario;
                        this.telefoneResponsavelSolicitacao = r.telefoneResponsavelSolicitacao;
                        this.listCitizen = r.cidadaos;
                        this.breveRelato = r.breveRelato;
                        this.enderecoSolicitacao = r.enderecoSolicitacao;
                        this.descricaoTipoSolicitacao = r.descricaoTipoSolicitacao;
                        this.codigoTipoServicoReordenamento = r.codigoTipoServicoReordenamento;
                        this.descricaoTipoServico = r.descricaoTipoServico;
                        this.tipoSolicitacao = r.tipoSolicitacao;
                        this.acolhimentoSeparado = r.acolhimentoSeparado;
                        this.tipoPerfilSolicitacao = r.perfilSolicitacao;
                        this.motivoIndeferimento = r.motivoIndeferimento;
                        this.descricaoMotivoIndeferimento = r.descricaoMotivoIndeferimento;
                        this.descricaoOrigemProcura = r.descricaoOrigemProcura;
                        this.descricaoOrgao = r.descricaoOrgao;
                        setTimeout(this.printWindow, 2000);
                    }
                } else {
                    this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                }
            }
            ).catch(error =>{
                this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                console.log(error);
            });
        }
    },
    filters: {
        TelefoneFormatado: function (value) {
            var formartMask = '';
            var telefone =  '';

            if (!value) return ''
            value = value.toString();
            formartMask = "(##) #####-####";
   
            
            if (formartMask != "")
             telefone = formatDefault(value,formartMask) ;
             else
             telefone = value;

            return  telefone ;
        }

    },
    methods:{
        async search(){
            try {
                this.loading = true;
                let data = this.getFilters();
                await this.$store.dispatch("request/listRequest", data);
                this.nodata = false;

            } catch (error) {
                this.error = error;
                this.nodata = true;
            }finally{
                this.loading = false;
            }
        },
       checkUserLogged(){
           var objLogin = this.$store.state.login;
           loginService.getOperator(objLogin.userLogin)
           .then(response => 
           { 
               console.log(response);
               return true; 
           }).catch(error => 
            { 
                if(error.toString().indexOf('code 401') != -1){
                    this.showSnackbar('Sessão expirada.', 'erro');
                    this.$router.push({ name: 'login' });
                }
            });
       },
       printWindow(){
           window.print();
       },
       testTextHasValue(value){
            return (value != null && value.length > 0);
       },               
    },
}


function formatDefault (value, mask) {
      
      let result = "";
      let count = 0;
      if (value) {
       
        let arrayValue = value.toString().split("");
        let arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    }
</script>
<style scoped>
tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
</style>